import { defineComponent as _defineComponent } from 'vue'
import SalesFlyerSideMenuContents from "./SalesFlyerSideMenuContents.vue";
import SideMenu from 'Src/js/components/SideMenu.vue';
import { SalesFlyerProductSearch } from "JS/sales-flyer/utilities/product-list";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerSideMenu',
  props: {
    search: null,
    flyerTitle: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close');
}), expose: any, slots: any, attrs: any }) {






return { __sfc: true,emit, SalesFlyerSideMenuContents, SideMenu }
}

})